export const handleKeyDown = (e) => {
    if (
        e.ctrlKey &&
        (e.key === '+' || e.key === '-' || e.key === '=' || e.key === '0')
    ) {
        e.preventDefault();
    }
};

export const handleWheel = (e) => {
    if (e.ctrlKey) {
        e.preventDefault();
    }
};

export const extractName = (str) => {
    if (typeof str !== 'string' || !str) return '';
    return str.split('@')[0];
};

export const getInitials = (name, email) => {
    if (name) {
        return name
            .split(' ')
            .map((n) => n.charAt(0))
            .join('');
    } else if (email) {
        return email
            .split('@')[0]
            .split('.')
            .map((n) => n.charAt(0))
            .join('');
    }
};
